import {
  RENEW_TOKEN_REQUEST,
  RENEW_TOKEN_SUCCESS,
  RENEW_TOKEN_FAILURE,
  CLEAR_RENEWAL_ERROR
} from './actions';

const initialState = {
  isRenewing: false,
  isSuccess: false,
  error: null,
  newToken: null,
  newExpiresAt: null,
  renewedAt: null,
  failedAt: null
};

const tokenRenewalReducer = (state = initialState, action) => {
  switch (action.type) {
    case RENEW_TOKEN_REQUEST:
      return {
        ...state,
        isRenewing: true,
        isSuccess: false,
        error: null,
        failedAt: null
      };

    case RENEW_TOKEN_SUCCESS:
      return {
        ...state,
        isRenewing: false,
        isSuccess: true,
        newToken: action.payload.newToken,
        newExpiresAt: action.payload.newExpiresAt,
        renewedAt: action.payload.renewedAt,
        error: null,
        failedAt: null
      };

    case RENEW_TOKEN_FAILURE:
      return {
        ...state,
        isRenewing: false,
        isSuccess: false,
        error: action.payload.error,
        failedAt: action.payload.failedAt,
        newToken: null,
        newExpiresAt: null,
        renewedAt: null
      };

    case CLEAR_RENEWAL_ERROR:
      return {
        ...state,
        error: null,
        failedAt: null
      };

    default:
      return state;
  }
};

export default tokenRenewalReducer;
